.features-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.features-scroll-wrapper::-webkit-scrollbar {
  display: none;
}

.clickable {
  text-decoration: none;
  color: inherit;
  transition: transform 0.2s ease;
}

.clickable:hover {
  transform: translateY(-2px);
}

.icon-wrapper {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  // background: linear-gradient(180deg, #fad207 0%, #faa515 100%);
}

.icon {
  width: 50px;
  height: 50px;
  margin: auto;
}

.title {
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  margin-top: 0.5rem;
  line-height: 1.2;
}
.padding_points {
  padding: 0px 5px;
}

.feature-item {
  width: 60px;
}
